var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStats = function SvgStats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 38 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.422 17.416h3.166v14.25h-3.166zM22.172 6.334h3.166v25.333h-3.166zM26.922 12.666h3.166v19h-3.166zM7.922 22.166h3.167v9.5H7.922zM12.672 14.25h3.166v17.417h-3.166z"
  })));
};
export default SvgStats;